import React from "react";
import { FaUsers, FaChalkboardTeacher, FaBook } from "react-icons/fa";
import "./Vision.css";

const visions = [
  {
    id: 1,
    title: "Self-reliance of Community Leaders",
    description:
      "Empowering leaders within the community to become self-sufficient, enabling them to lead initiatives and create lasting change.",
    icon: <FaUsers />,
  },
  {
    id: 2,
    title: "Social Awareness and Training",
    description:
      "Conducting awareness programs to address critical social issues, such as drug eradication, cleanliness, and women's rights.",
    icon: <FaChalkboardTeacher />,
  },
  {
    id: 3,
    title: "Education and Relief Programs",
    description:
      "Providing educational opportunities, especially for women and children, and distributing relief materials to those affected by natural disasters like floods and earthquakes.",
    icon: <FaBook />,
  },
];

const Vision = () => {
  return (
    <section className="vision-section-home">
      <div className="vision-container-home">
        <h2 className="vision-title-home">Our <span>Vision</span></h2>
        <div className="vision-grid-home">
          {visions.map((vision, index) => (
            <div
              className="vision-card-home"
              key={vision.id}
              data-aos="fade-up"
              data-aos-delay={index * 150}
            >
              <div className="vision-icon-home">{vision.icon}</div>
              <h3 className="vision-card-title-home">{vision.title}</h3>
              <p className="vision-card-text-home">{vision.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Vision;
